<template>
  <div class="allContent">
    <div class="game_title">
      <img
        src="../../assets/saveCardActivity/test1.png"
        alt=""
      />
      <div>
        <!-- <img
          :src="
            `https://oss.zhekoushenqi.com/data/homegameActivity/icon_dowland.png?t=${state.nowDay}`
          "
          alt=""
          @click="goGamedetails"
        /> -->
      </div>
    </div>

    <!-- 活动抽奖 -->
    <activityLottery
      :lotteryNum="state.lotteryNum"
      :token="state.token"
      :nowDay="state.nowDay"
      :lotteryList="state.lotteryList"
      @getActivity="getActivity"
    />

    <!-- 任务信息 -->
    <!-- <taskInfo
      :video_url="state.gameVideo"
      :poster="state.gamePoster"
      :isLogin="state.isLogin"
      :isPay="state.isPay"
      :otherLog="state.otherLog"
      :gameName="state.gameName"
      :activityStatus="state.activityStatus"
      :gid="state.gid"
      :nowDay="state.nowDay"
    /> -->

    <!-- 游戏信息 -->
    <gameinfoSwiper :swiperList="state.gamePhoto" :nowDay="state.nowDay" />
    <!-- 活动信息 -->
    <div class="activity_info">
      <activityInfo
        :myLog="state.myLog"
        :nowDay="state.nowDay"
        :activeTime="state.activeTime"
        :guize="state.guize"
      />
    </div>
  </div>
</template>
<script setup>
import { onMounted, ref, reactive, nextTick, onActivated } from "vue";

// 拆分组件
import activityInfo from "./homeSaveCard/activityInfo.vue";
import activityLottery from "./homeSaveCard/activityLottery.vue";
import taskInfo from "./homeSaveCard/taskInfo.vue";
import gameinfoSwiper from "./homeSaveCard/gameinfoSwiper.vue";
import lottery from "./lottery.vue";

import { detect } from "@/utils/device";
import { getQueryString } from "@/utils/location";

import { getactivityInfo } from "@/api/activity";
import { Toast } from "vant";
import { setToken, getToken } from "@/utils/auth";

const state = reactive({
  gid: "",
  token: "",
  activityInfo: {},
  lotteryList: [],
  gamePhoto: [],
  gameVideo: "",
  gamePoster: "",
  lotteryNum: 0,
  isLogin: 0,
  isPay: 0,
  otherLog: [],
  gameName: "",
  activityStatus: 0,
  // 今儿的日期
  nowDay: "",
  activeTime: "",
  guize: "",
});

onMounted(() => {
  // 设置token
  if (getQueryString("token") != "undefined") {
    setToken(getQueryString("token"));
    state.token = getQueryString("token");
  } else {
    setToken(route.query.token);
    state.token = route.query.token;
  }
  // 初始化获取活动信息
  getActivity();
});
onActivated(() => {
  state.nowDay = getCurrentTimestamp();
  // console.log("onActivated日期-----------", state.nowDay);
});

// 获取活动信息
const getActivity = () => {
  // getactivityInfo({
  //   token: state.token,
  // }).then((res) => {
  //   console.log("获取到的活动信息-----------", res.data.data);
  //   // state.activityInfo = res.data.data;
  //   // state.lotteryList = res.data.data.lotterylists;
  //   // state.gamePhoto = res.data.data.photo;
  //   // state.gameVideo = res.data.data.videourl;
  //   // state.gamePoster = res.data.data.videoimg;
  //   // state.lotteryNum = res.data.data.cjcs;
  //   // state.isLogin = res.data.data.isLogin;
  //   // state.isPay = res.data.data.isPay;
  //   // state.otherLog = res.data.data.lottery_log_other;
  //   // state.gameName = res.data.data.gamename;
  //   // state.myLog = res.data.data.lottery_log;
  //   // state.gid = res.data.data.gid;
  //   // state.activityStatus = res.data.data.status;
  //   // state.activeTime = res.data.data.time;
  //   // state.guize = res.data.data.guize;

    
  // });

  state.gamePhoto = [
      {url: "https://oss.zhekoushenqi.com/data/upload/game/20250830/68b2dc5247b18.png"},
      {url: "https://oss.zhekoushenqi.com/data/upload/game/20250830/68b2dc526b300.png"},
      {url: "https://oss.zhekoushenqi.com/data/upload/game/20250830/68b2dc5286094.png"},
      {url: "https://oss.zhekoushenqi.com/data/upload/game/20250830/68b2dc529d0fa.png"},
      {url: "https://oss.zhekoushenqi.com/data/upload/game/20250830/68b2dc5319422.png"}]
    state.lotteryNum = 0
    state.lotteryList = [""]
    state.gid = "2554"
    state.gameName = "仙灵物语-免费版"
    state.guize = `1.活动奖励：平台7天省钱卡（价值20元，领取后仅增加天数，无立返福利币，具体权益以平台展示为准）；
2. 领取条件：当游戏角色等级达到40级后（达到等级后如等级未刷新，请重新启动游戏）；
3. 领取方式：满足领取条件后，玩家可通过活动中心指定入口进行领取；
4. 领取限制：每个用户仅限领取一次，奖励领取后将直接发放至玩家的平台账户中；
5.为保证活动公平性，每个用户仅可参与领取一次奖励；
6.如发现用户存在作弊、刷奖等违规行为，活动主办方有权取消其活动参与资格及奖励领取资格，必要时将追究法律责任；
7. 活动主办方拥有对本活动规则的最终解释权，如有活动调整将通过游戏内公告或平台公告另行通知。`

  
};

// 跳转到游戏详情页
const goGamedetails = () => {
  if(!state.gid){
    return
  }

  if (detect() == "android" || detect() == "harmony") {
    window.document.location = "gogame://" + state.gid;
  } else {
    var eventData = {
      eventType: "openEvent",
      gid: state.gid,
    };
    window.parent.postMessage(eventData, "*");
  }
  // console.log("跳转到游戏详情页--------",state.gid);
};

const getCurrentTimestamp = () => {
  return `${new Date().getMonth() +
    1}-${new Date().getDate()}-${new Date().getHours()}-${new Date().getMinutes()}`;
};
</script>
<style scoped>
.allContent {
  height: 100vh;
  overflow: auto;
  overflow-x: hidden;
  /* padding-bottom:100px; */
}
.allContent .game_title {
  height: 915px;
  width: 100%;
}
.game_title div {
  color: #fff;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -20px;
}
.game_title div img {
  width: 357px;
  height: 160px;
}
img {
  height: 100%;
  width: 100%;
  vertical-align: bottom;
}

/* 活动信息 */
.activity_info {
  position: fixed;
  right: 0;
  bottom: 55%;
  z-index: 99;
}
.activity_info :deep(.van-popup) {
  background-color: rgba(0, 0, 0, 0);
}
.activity_info :deep(.van-overlay) {
  background-color: rgba(0, 0, 0, 0.7);
}
.activity_info :deep(.van-checkbox__icon .van-icon) {
  border: 1px solid #fff;
}
</style>
